export interface CrmStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export function createStorage(): CrmStorage {
  const memory = new Map<string, string>();

  try {
    const testKey = "__rxexr_storage_test__";
    window.localStorage.setItem(testKey, "1");
    window.localStorage.removeItem(testKey);
    return window.localStorage;
  } catch {
    return {
      getItem(key) {
        return memory.has(key) ? memory.get(key) ?? null : null;
      },
      setItem(key, value) {
        memory.set(key, String(value));
      },
      removeItem(key) {
        memory.delete(key);
      },
    };
  }
}
